// @ts-strict-ignore
import { Component, OnInit } from "@angular/core";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import * as C from "../../../../../../shared/constants/globals.constants";

@Component({
  selector: C.EWIZ_ISIM_SERVICE_TABLE_CONFIGURATION,
  templateUrl: "./isim-service-table-configuration.component.html",
  standalone: false
})
export class EWizISIMServiceTableConfigurationComponent extends EWizDynamicBaseClassComponent implements OnInit {
  private readonly services = [
    "P-CSCF address",
    "Generic Bootstrapping Architecture (GBA)",
    "HTTP Digest",
    "GBA-based Local Key Establishment Mechanism",
    "Support of P-CSCF discovery for IMS Local Break Out",
    "Short Message Storage (SMS)",
    "Short Message Status Reports (SMSR)",
    "Support for SM-over-IP including data download via SMS-PP as defined in TS 31.111",
    "Communication Control for IMS by ISIM",
    "Support of UICC access to IMS",
    "URI support by UICC",
    "Media Type Support",
    "IMS call disconnection cause",
    "URI Support for MO SHORT MESSAGE CONTROL",
    "Mission Critical Services",
    "URI Support for SMS-PP Download as defined in 3GPP TS 31.111",
    "From Preferred",
    "IMS configuration data",
    "XCAP configuration data",
    "WebRTC URI",
    "MuD and MiD configuration data"
  ];

  public isimToTitle: Map<string, string> = new Map<string, string>();

  ngOnInit() {
    this.profileValues.isimServiceTableVisited = true;
    if (this.profileValues.isimConfiguration.gbaUserAuthentication === "1") {
      this.profileValues.isimServiceTable.isimService2 = true;
    }
    Object.keys(this.profileValues?.isimServiceTable || {})?.forEach((key, i) => this.isimToTitle.set(key, this.services[i]));
    this.handleFormEvents();
  }
  // required for KeyValuePipe
  preserveOrder = () => {
    return 0;
  };
}
